import React from 'react';
import ReactDOM from 'react-dom';
import { FormGroup, Alert } from 'react-bootstrap';
import {
  FormControl,
  Button,
} from '../form/FormControls.jsx';
import {CenterBox, LinkLikeButton, navTo} from '../../util/util.jsx';
import { Map } from 'immutable';
import { tryToLogin, retrieveBlockTime } from '../../store/session.store';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import './auth.css';
import { Header } from '@/component/header/Header.jsx';
import Cookies from 'js-cookie';
import {clearLink} from "../blogic/deals/store/deal.store";

// wrap it all app, get rid of redundant stuff

const mapStateToProps = (state) => ({
  errors: state.getIn(['error', 'login_error']),
  mfaCodeRequired: state.getIn(['session', 'mfaCodeRequired']),
  blockTime: state.getIn(['session', 'blockTime'], new Map()),
  blockTimeFailureFlag: state.getIn(['session', 'blockTimeFailureFlag'], false),
  nextLocation: state.getIn(['routing', 'locationBeforeTransitions', 'state', 'nextPathname']),
});

const mapDispatchToProps = (dispatch) => ({
  login: (user, pass, mfaCode, location) => tryToLogin(dispatch, user, pass, mfaCode, location),
  retrieveBlockTime: () => retrieveBlockTime(dispatch),
});

class AuthClass extends React.Component {
  constructor(args) {
    super(args);
    this.handleUserNameChange = this.handleUserNameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.getBlockTimeRemaining = this.getBlockTimeRemaining.bind(this);
    this.handleMfaCode = this.handleMfaCode.bind(this);
    this.state = {
      username: '',
      password: '',
      mfaCode: null,
    };
    document.title = 'Login';
  }
  componentWillMount() {
    const browserId = Cookies.get('browserId');
    if (!browserId) {
      const id = Math.random().toString(36).substring(2)
             + (new Date()).getTime().toString(36);
      Cookies.set('browserId', id, { expires: 3650 });
    }
    this.props.retrieveBlockTime();
  }

  componentWillReceiveProps(props) {
    if (!props.blockTime.get('remaining')) {
      const node = ReactDOM.findDOMNode(this.refs.username);
      if (node) {
        node.focus();
      }
    } else {
      this.setState({ blockReleased: false });
      setTimeout(() => this.setState({ blockReleased: true }),
        parseInt(props.blockTime.get('remaining'), 10) * 1000);
    }
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.login(
      this.state.username,
      this.state.password,
      this.state.mfaCode,
      this.props.nextLocation); // add location here
  }

  getBlockTimeRemaining() {
    if (this.state.blockReleased) {
      return 0;
    }
    return this.props.blockTime.get('remaining');
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value, username: this.state.username });
  }

  handleUserNameChange(event) {
    this.setState({ username: event.target.value, password: this.state.password });
  }

  handleMfaCode(event) {
    this.setState({ mfaCode: event.target.value });
  }

  render() {
    const ipBlocked = (this.getBlockTimeRemaining() === undefined
      || this.getBlockTimeRemaining() > 0) && !this.props.blockTimeFailureFlag;
    const { blockTime, mfaCodeRequired } = this.props;
    return (
      <div>
        <Header loginScreen />
        <CenterBox
          width="500px" height="300px"
          style={{ paddingTop: '56px', background: '#f0f0f0' }}
        >
          <form
            onSubmit={this.onSubmit}
            style={{ padding: '20px 80px', background: 'white', border: 'thin solid lightgray' }}
          >
            <FormGroup>
              <center>
                <h4>
                  Log in to ERP system
                </h4>
              </center>
            </FormGroup>
            <FormGroup>
              <FormControl
                type="text" name="login" placeholder="Enter your login here"
                value={this.state.username} onChange={this.handleUserNameChange}
                disabled={ipBlocked} autoComplete="username" autoFocus
                ref="username"
              />
            </FormGroup>
            <FormGroup>
              <FormControl
                type="password" name="password" placeholder="Enter your password here"
                value={this.state.password} onChange={this.handlePasswordChange}
                disabled={ipBlocked} autoComplete="current-password"
              />
            </FormGroup>
            {mfaCodeRequired ?
              <FormGroup>
                <FormControl
                  type="text" name="mfa" placeholder="MFA code"
                  value={this.state.mfaCode} onChange={this.handleMfaCode}
                  disabled={ipBlocked} maxLength="6"
                />
              </FormGroup>
              :
              ''
            }
            <FormGroup>
              <Button
                id="signin"
                type="submit"
                bsStyle="primary"
                style={{ width: '100%' }}
                disabled={ipBlocked}
              >
                Log In
              </Button>
            </FormGroup>
            <LinkLikeButton onClick={() => navTo(`/reset-password`)}>
              Forgot password
            </LinkLikeButton>
            <ReactCSSTransitionGroup
              transitionName="example" transitionEnterTimeout={500} transitionLeaveTimeout={300}
            >
              {ipBlocked && blockTime.get('total') ?
                <Alert bsStyle="default" className="has-error" style={{ padding: 0 }}>
                  <div className="help-block" style={{ fontSize: 'medium' }}>
                    {`You made too many unsuccessful login attempts.
                  Wait for ${blockTime.get('total')} seconds since last attempt`}
                  </div>
                </Alert> :
                ''
              }
              {!ipBlocked && this.props.errors ?
                <Alert bsStyle="default" className="has-error" style={{ padding: 0 }}>
                  <div className="help-block" style={{ fontSize: 'medium' }}>
                    {this.props.errors}
                  </div>
                </Alert> :
                ''}

              {this.props.blockTimeFailureFlag ?
                <Alert bsStyle="default" className="has-error" style={{ padding: 0 }}>
                  <div className="help-block" style={{ fontSize: 'medium' }}>
                    Connection to server is terminated
                  </div>
                </Alert> :
                ''}
            </ReactCSSTransitionGroup>
          </form>
        </CenterBox>
      </div>);
  }
}
AuthClass.propTypes = {
  errors: React.PropTypes.node,
  login: React.PropTypes.func,
  nextLocation: React.PropTypes.string,
  retrieveBlockTime: React.PropTypes.func,
  blockTime: React.PropTypes.bool,
  blockTimeFailureFlag: React.PropTypes.bool,
  mfaCodeRequired: React.PropTypes.bool,
};

export const Auth = connect(mapStateToProps, mapDispatchToProps)(AuthClass);
